/**
 * エラーユーティリティ
 */
import ApplicationError from '../ApplicationError';

const SYSTEM_ERROR_TITLE = 'error.system_error_title';
const SYSTEM_ERROR_DESCRIPTION = 'error.system_error_description';

/**
 * 共通エラー情報取得
 * @param {Error} error 例外オブジェクト
 * @param {function} handler ユーザーハンドラー
 */
function getErrorInfo(error, handler) {
  // サポートされるエラー言語リソース
  // error.system_error_title
  // error.system_error_description
  // error.page_not_found_title
  // error.fetch_error_title
  // error.fetch_error_description
  // error.already_registered_title
  // error.already_registered_description
  // error.not_registered_title
  // error.not_registered_description
  // error.expired_code_title
  // error.expired_code_description
  // error.passwordreset_timeout_title
  // error.passwordreset_timeout_description
  // error.not_migrated_title
  // error.not_migrated_description
  // error.invalid_operation_state_title
  // error.invalid_operation_state_description
  if (error instanceof ApplicationError) {
    if (handler) {
      let res = handler(error);
      if (res) {
        return res;
      }
    }
    let title = `error.${error.description.code}_title`;
    let description = `error.${error.description.code}_description`;
    let optional = null;
    return { code: error.description.code, title: title, description: description, optional: optional };
  } else {
    return { code: 'system_error', title: SYSTEM_ERROR_TITLE, description: SYSTEM_ERROR_DESCRIPTION, optional: null };
  }
}

const exportUtils = {
  getErrorInfo: getErrorInfo
};
export default exportUtils;
